<template>
  <div>
    <h1 class="text-center">
      Password Reset
    </h1>
    <form ref="form" method="POST">
      <br>
      <p>You may set a new password below. Your password must meet certain strength requirements, i.e. at least 4 of the 5 bars must be colored green. Do not use your username or email in your password.</p>
      <br>
      <p>
        <password
          v-model="password"
          :badge="false"
          name="password"
          placeholder="Please select a password"
        />
        <password
          id="confirmPass"
          v-model="confirmPassword"
          :badge="false"
          name="password2"
          placeholder="Please confirm your password"
          strengthMeterClass="d-none"
        />
      </p>
      <input :value="csrf_token" type="hidden" name="_csrf_token">
      <button :disabled="!isReady()" type="submit" class="btn btn-primary">
        Submit
      </button>
      <a :href="homeUrl" class="btn btn-default">Cancel</a>
      <i
        v-if="isReady()"
        class="fa fa-check"
        style="color: green; font-size: 1.5em; vertical-align: middle; padding-left: 15px;"
      />
    </form>
  </div>
</template>

<script>
  import Password from 'vue-password-strength-meter';

  export default {
    components: {
      Password
    },
    props: {
      homeUrl: {
        type: String,
        default: ''
      },
      csrf_token: {
        type: String
      }
    },
    data: function() {
      return {
        password: null,
        confirmPassword: null
      }
    },
    methods: {
      strength() {
        return this.$children[0] ? this.$children[0].passwordStrength : 0;
      },
      isReady() {
        return (this.password === this.confirmPassword) && this.strength() >= 3;
      }
    },
  }
</script>
